import { EventEmitter, Injectable } from '@angular/core';

export type ErrorEmptyPage = { code: number; message: string };

@Injectable({ providedIn: 'root' })
export class ErrorPageService {
    errorData = new EventEmitter<ErrorEmptyPage>();
}
